import { Group, Circle, Wedge, Line, Text } from "react-konva";

// Hidden templates only ever reach a GM's client (the backend filters them out of a player's
// list response entirely) — rendered here as a faint dashed "ghost" outline so the GM can still
// see/select/edit the trap zone, instead of the normal solid-fill AOE look real players see.
export default function TemplateShape({ template, canEdit, onDragEnd, onSelect, isSelected }) {
  const { shape, size, color, rotation, label, hidden } = template;
  const fill = hidden ? `${color}11` : `${color}33`;
  const stroke = hidden ? "#D4AF37" : color;
  const dash = hidden ? [6, 5] : undefined;

  return (
    <Group
      x={template.x}
      y={template.y}
      rotation={rotation}
      draggable={canEdit}
      onClick={onSelect}
      onTap={onSelect}
      onDragEnd={(e) => onDragEnd(template.id, e.target.x(), e.target.y())}
      data-testid={`template-${template.id}`}
      opacity={hidden ? 0.6 : 1}
    >
      {shape === "circle" && <Circle radius={size / 2} fill={fill} stroke={stroke} strokeWidth={isSelected ? 3 : 2} dash={dash} />}
      {shape === "cone" && <Wedge radius={size} angle={53} fill={fill} stroke={stroke} strokeWidth={isSelected ? 3 : 2} rotation={-26.5} dash={dash} />}
      {shape === "line" && <Line points={[0, 0, size, 0]} stroke={stroke} strokeWidth={isSelected ? 8 : 6} opacity={hidden ? 1 : 0.6} lineCap="round" dash={dash} />}
      {label && <Text text={`${label}${hidden ? " (hidden)" : ""}`} fontSize={11} fill="#f1e0c5" y={shape === "circle" ? -size / 2 - 14 : -14} width={100} align="center" x={-50} />}
    </Group>
  );
}
